import { FormattedMessage } from "react-intl";
import { Space } from "antd";
import Header from "components/layout/Header";
import Typography from "components/common/Typography";
import ButtonLink from "components/common/ButtonLink";
import { ROUTE_PATHS } from "const/paths";
import { generatePath } from "react-router-dom";
import { EventType } from "@ticketingplatform/api/dist/__generated__/globalTypes";

const Events = () => (
  <Header>
    <Space direction="vertical">
      <Typography.Title>
        <FormattedMessage defaultMessage="Create recurring event" />
      </Typography.Title>

      <Space>
        <ButtonLink
          type="primary"
          block
          to={generatePath(ROUTE_PATHS.RecuringEventCreate, {
            type: EventType.TICKETED.toLowerCase(),
          })}
        >
          <FormattedMessage defaultMessage="Ticketed" />
        </ButtonLink>
        <ButtonLink
          type="primary"
          to={generatePath(ROUTE_PATHS.RecuringEventCreate, {
            type: EventType.NONTICKETED.toLowerCase(),
          })}
        >
          <FormattedMessage defaultMessage="Non-Ticketed" />
        </ButtonLink>
      </Space>
    </Space>
  </Header>
);

export default Events;
